module.exports = __webpack_public_path__ + "img/new-banner.6dca81da.svg";